import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import logoDots from './assets/logo-dots.svg'
import logoText from './assets/logo-text.svg'
import whatsappIcon from './assets/whatsapp.svg'

const PAGE_BG = '#e5e6ec'
const FOOTER_BORDER = '#e5e7eb'
const FOOTER_TEXT = '#4a5565'

const Page = styled.div`
  direction: rtl;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: white;
  font-family: liebling, system-ui, sans-serif;
`

const Main = styled.main`
  flex: 1;
  min-height: 0;
  background: ${PAGE_BG};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  gap: 48px;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 32px;
  }
`

const LogoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 19px;
`

const LogoDots = styled.img`
  width: 161.18px;
  height: 99.58px;
`

const LogoText = styled.img`
  width: 203.43px;
  height: 24.93px;
`

const Footer = styled.footer`
  background: white;
  border-top: 0.909px solid ${FOOTER_BORDER};
  padding-top: 24.9px;
  height: 69px;
  display: flex;
  justify-content: center;
`

const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  height: 20px;
`

const FooterLink = styled.a`
  font-family: liebling, system-ui, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: ${FOOTER_TEXT};
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  &:hover { border-bottom: none; color: ${FOOTER_TEXT}; }
`

const WhatsAppIcon = styled.img`
  width: 20.57px;
  height: 20.5px;
`

interface Props {
  children: ReactNode
}

const AuthLayout: FC<Props> = ({ children }) => (
  <Page>
    <Main>
      <LogoBlock>
        <LogoDots src={logoDots} alt="" />
        <LogoText src={logoText} alt="mekomenet" />
      </LogoBlock>
      {children}
    </Main>
    <Footer>
      <FooterRow>
        <FooterLink href="https://wa.me/" target="_blank" rel="noreferrer">
          שירות לקוחות
          <WhatsAppIcon src={whatsappIcon} alt="" />
        </FooterLink>
        <FooterLink href="#">תנאי שימוש</FooterLink>
        <FooterLink href="#">מדיניות פרטיות</FooterLink>
      </FooterRow>
    </Footer>
  </Page>
)

export default AuthLayout
